import { Link } from 'react-router-dom';

export function SiteFooter() {
  return (
    <footer className="border-t border-border-subtle bg-background-secondary">
      <div className="mx-auto w-full max-w-[1440px] px-6 py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="space-y-4">
            <div className="text-sm font-semibold text-text-primary">
              iValue RegTech CoE
            </div>
            <div className="text-sm text-text-secondary">
              Engineering compliance. Automating trust. Scaling regulation.
            </div>
            <div className="flex flex-wrap gap-2">
              <div className="rounded-full border border-border-subtle bg-white/5 px-3 py-1 text-xs font-semibold text-text-secondary">
                ISO 27001
              </div>
              <div className="rounded-full border border-border-subtle bg-white/5 px-3 py-1 text-xs font-semibold text-text-secondary">
                SOC 2
              </div>
              <div className="rounded-full border border-border-subtle bg-white/5 px-3 py-1 text-xs font-semibold text-text-secondary">
                WCAG 2.1 AA
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
              Frameworks
            </div>
            <div className="space-y-2 text-sm">
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/india/rbi">
                RBI Compliance
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/india/cert-in">
                CERT-In
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/india/sebi-cscrf">
                SEBI CSCRF
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/india/irdai">
                IRDAI
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/international/iso-27001">
                ISO 27001
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/international/pci-dss">
                PCI-DSS
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/frameworks/international/nist-csf">
                NIST CSF
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/ot-security">
                OT Security
              </Link>
            </div>
          </div>

          <div className="space-y-3">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
              Resources
            </div>
            <div className="space-y-2 text-sm">
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/whitepapers">
                Whitepapers
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/control-maps">
                Control Maps
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/calculators">
                Calculators
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/blueprints">
                Blueprints
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/case-studies">
                Case Studies
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/webinars">
                Webinars
              </Link>
              <Link className="block text-text-secondary hover:text-text-primary" to="/resources/blog">
                Blog
              </Link>
            </div>
          </div>

          <div className="space-y-3">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
              Contact
            </div>
            <div className="space-y-2 text-sm text-text-secondary">
              <div>iValue Group (India-HQ) No. 903/1/1, 19th Main Road, 4th Sector, H.S.R. Layout, Bangalore – 560102</div>
              <div>+91 95359 99473</div>
              <div>info@ivalue.co.in</div>
              <div className="pt-2">
                <Link className="text-text-secondary hover:text-text-primary" to="/contact#contact-form">
                  Contact →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-border-subtle">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-3 px-6 py-6 text-sm text-text-muted md:flex-row md:items-center md:justify-between">
          <div>© {new Date().getFullYear()} iValue</div>
          <div className="flex gap-4">
            <Link className="hover:text-text-primary" to="/privacy">
              Privacy
            </Link>
            <Link className="hover:text-text-primary" to="/terms">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
